import { render } from "./lateral_indicadores.vue?vue&type=template&id=3763f848"
import script from "./lateral_indicadores.vue?vue&type=script&lang=js"
export * from "./lateral_indicadores.vue?vue&type=script&lang=js"

import "./lateral_indicadores.vue?vue&type=style&index=0&id=3763f848&lang=css"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__